/**
 * Both the composition root and its step-content renderer need to know which step is active --
 * kept in one place so the step-index-to-meaning mapping can't drift between the two.
 */
export function getActiveStepFlags(activeStep: number) {
  return {
    isCapacityStep: activeStep === 6,
    isPackageSetupStep: activeStep === 8,
    isPrerequisitesStep: activeStep === 1,
    isPropertyStep: activeStep === 2,
    isRatePlanStep: activeStep === 4,
    isRoomRatesStep: activeStep === 5,
    isRoomStep: activeStep === 3,
    isSubmissionStep: activeStep === 9,
    isTaxesAndFeesStep: activeStep === 7,
  };
}
